<template>
  <button
  type="button"
    :disabled="disabledBtn"
    @click.stop.prevent="buttonHandler"
    :class="`
    ${btnBorder ? `border border-${borderColor} ` : ''}
    bg-${btnColor} hover:bg-opacity-75
    text-${textColor}
    ${btnSizeVal === 'large' ? 'py-3 px-5 cta-text' : ''}
    ${btnSizeVal === 'medium' ? 'py-2 px-5 cta-text' : ''}
    ${btnSizeVal === 'small' ? 'py-1 px-3 heading-6' : ''}
    ${disabledBtn ? 'opacity-20 cursor-auto ' : ''}
    ${isSqure ? '' : 'rounded-full'}
    `"
    class=" shadow cursor-pointer hover:shadow-xl global_btn"
  >
    {{ btnText }}
  </button>
</template>
<script>
export default {
  props: [ "isSqure", "btnText", "btnSize", "btnColor", "textColor", "disabled", "btnBorder", "borderColor"],
  data() {
    return {
      disabledBtn: false,
      screenWidth: 0,
      btnSizeVal: ''
    };
  },
  watch: {
    disabled: {
      handler() {
        if (this.disabled) {
          this.disabledBtn = this.disabled;
        } else {
          this.disabledBtn = this.disabled;
        }
      },
    },
  },
  created() {
    window.addEventListener("resize", this.resizeWindowHandler);
  },
  mounted() {
    if (window.innerWidth < 640) {
        this.btnSizeVal = 'small'
      } else{
        this.btnSizeVal = this.btnSize
      }
    // console.log('window.innerWidth ', window.innerWidth );
    if (this.disabled) {
      this.disabledBtn = this.disabled;
    }
  },
  methods: {
    resizeWindowHandler() {
      this.screenWidth = window.innerWidth
      if (window.innerWidth < 640) {
        this.btnSizeVal = 'small'
      } else {
        this.btnSizeVal = this.btnSize
      }
    },
    buttonHandler() {
      this.$emit("buttonAction");
    },
  },
};
</script>
<style scoped>
.goTop_btn {
  position: fixed;
  bottom: 25px;
  right: 25px;
  z-index: 1000;
}
</style>

